import { Box, Button, Tooltip } from "@mui/material";
import React from "react";

const TaskStatusCard = ({
  title,
  data,
  qtyColorText = "",
  cardWidth,
  tooltip = "",
  total,
  eec = "",
  onClick = null,
}) => {
  const styles = {
    container: {
      //   backgroundColor: statusFocused == status_id ? "rgba(24,118,209,0.3)" : "",
      width: cardWidth ?? "",
      cursor: onClick ? "pointer" : "default",
      "&:hover": {
        background: onClick ? "rgba(0,0,0,0.05)" : "",
      },
      //   height: cardHeight ? cardHeight : "150px",
    },
    qtyStyle: {
      color: qtyColorText,
    },
  };
 

  if(!total)
  return (
    <div 
      className="card shadow border-success" 
      style={styles.container}
      onClick={onClick}
      role={onClick ? "button" : undefined}
    >
      <div className="card-body">
        <div className={`display-3 `} style={styles.qtyStyle}>
          <Tooltip title={tooltip} placement="left-start">
            <Box> {data}</Box>
          </Tooltip>
        </div>

        <div className=""> 
                        {title}</div>
      </div>
    </div>
  );
  else
  return (
    <div 
      className="card shadow border-success" 
      style={styles.container}
      onClick={onClick}
      role={onClick ? "button" : undefined}
    >
      <div className="card-body">
        <div className={`display-3 `} style={styles.qtyStyle}>
          <Tooltip title={tooltip} placement="left-start">
            <Box> {data}</Box>
          </Tooltip>
        </div>

        <div className=""> <span class ="badge badge-soft-success me-2"> {`${Math.round(
                          (data/total) *100
                        )}%`} </span>
                        {title}</div>
      </div>
    </div>
  );


};

export default TaskStatusCard;
